import { restClient } from '../config/restClient'

export const getInitialState = async (companyId, hiringTeamId) => {
  let url = `/company/${companyId}/initial_state`
  url = hiringTeamId ? `${url}?current_hiring_team_id=${hiringTeamId}` : url
  const response = await restClient(url, { method: 'GET' })

  return response
}
